import { render, staticRenderFns } from "./ConceptContacts.vue?vue&type=template&id=610bdbb6&scoped=true"
import script from "./ConceptContacts.vue?vue&type=script&lang=ts"
export * from "./ConceptContacts.vue?vue&type=script&lang=ts"
import style0 from "./ConceptContacts.vue?vue&type=style&index=0&id=610bdbb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610bdbb6",
  null
  
)

export default component.exports